import React from "react";
import { Box, Text } from "@mantine/core";

export const ChatTypingAnimation = ({ input }) => {
  return (
    <Box
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "10px",
        gap: "5px",
      }}
    >
      <Text size="sm" style={{ marginRight: "8px" }}>
        {input}
      </Text>
      <Box style={{ display: "flex", gap: "4px" }}>
        {[0, 1, 2].map((index) => (
          <Box
            key={index}
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#3498db",
              animation: `blink 1.4s infinite ${index * 0.2}s`,
            }}
          />
        ))}
      </Box>
      <style>
        {`
          @keyframes blink {
            0% { opacity: 0.2; }
            20% { opacity: 1; }
            100% { opacity: 0.2; }
          }
        `}
      </style>
    </Box>
  );
};
